
import React from 'react'
import loader from "../../assets/images/loader.gif";

export default ({onClick}) => {
  return (<div className="text-center"><img  alt="loader" src={loader} /></div>
 )
}